import { useMutation } from '@tanstack/react-query';
import { ConsentsApi } from '@digiwedge/access-control-api-client';
import { createAccessControlConfiguration, createAccessControlQueryScope, useAccessControlContext, } from './AccessControlApiProvider.js';
export function useConsentsControllerUpdateMutation(options) {
    const accessControlContext = useAccessControlContext();
    const accessControlScope = createAccessControlQueryScope(accessControlContext);
    const accessControlConfig = createAccessControlConfiguration(accessControlContext);
    return useMutation({
        mutationKey: ['consentsControllerUpdate', accessControlScope],
        mutationFn: async (args) => {
            const api = new ConsentsApi(accessControlConfig);
            return api.consentsControllerUpdate(...args);
        },
        ...options,
    });
}
//# sourceMappingURL=useConsentsControllerUpdateMutation.js.map